import { detect } from 'detect-browser';
export var getOs = function getOs() {
  var _browser$os;
  var browser = detect();
  return browser && ((_browser$os = browser.os) === null || _browser$os === void 0 ? void 0 : _browser$os.toLocaleLowerCase()) || '';
};